<script>

  import Document from './Document.svelte';

  export let step = undefined

</script>

<!-- amendmend -->
<div class="doc doc-2" class:shifted="{ 3 < step && step <= 5 || 8 < step }">
  <Document 
    outlineColor={step <= 5 ? 'var(--color-blue-light)' : 'var(--color-blue-dark)'}
    show={{
      self:       (step > 3 && step < 6) || step > 8,
      draft:      0,
      title:      0, 
      copy:       0, 
      checkmarks: 0,
      seal:       0
    }}
  />
</div>
<!-- draft -->
<div class="doc doc-1" class:shifted="{ 3 < step && step <= 5 || 8 < step }">
  <Document 
    outlineColor={step <= 5 ? 'var(--color-blue-light)' : 'var(--color-blue-dark)'}
    show={{
      self:       step > 0 && step < 6,
      draft:      1,
      title:      0,
      copy:       0,
      checkmarks: step > 1,
      seal:       step > 2
    }}
  />
</div>
<!-- cwc -->
<div class="doc doc-1" class:shifted="{ 3 < step && step <= 5 || 8 < step }">
  <Document 
    outlineColor={step <= 5 ? 'var(--color-blue-light)' : 'var(--color-blue-dark)'}
    show={{
      self:       step > 5,
      draft:      0,
      title:      1, 
      copy:       1, 
      checkmarks: step > 6,
      seal:       step > 7
    }}
  />
</div>


<style>
  .doc {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 30%;
    transition: transform 0.4s ease-out;
  }

  .doc-1.shifted {
    transform: translate(-17px, 4px) rotate(-6deg);
  }

  .doc-2.shifted {
    transform: translate(2px, -6px) rotate(6deg);
  }
</style>